<template>
  <div class="recordModel">
    <Drawer size="92%" :with-header="false" direction="btt" :visible.sync="status" :modal-append-to-body="false" :wrapperClosable="false"
      @close="closeRecord">
      <div class="fMain">
        <div class="fHead flexBw">{{isSingle ? 'AI 点读练习' : 'AI全文练习'}} <span class="el-icon-close close" @click="status = false"></span></div>
        <div class="flexBw fWrap">
          <div class="fLeft" :class="isSingle && 'noPad'">
            <slot v-if="isSingle"></slot>
            <template v-else>
              <p class="fTip">本篇内容共 {{ artObj.count }} 个汉字</p>
              <LyricManager :txts="artObj.content" v-if="status" />
            </template>
            <div class="mask" v-show="isRecord" v-if="isSingle"></div>
          </div>
          <div class="fRight">
            <div class="frWrap flex">
              <div class="fModel fMedia">
                <div class="fTitle flex"><span class="iconfont weixuanzhong"></span> AI 全文练习提示</div>
                <div class="fmTip">
                  <p class="fTip">1. 请录音时，尽可能保持环境安静，确保最终录音质量</p>
                  <p class="fTip">2. 请选择正确的录音设备参与本次的练习</p>
                </div>
                <div class="fTitle flexBw" style="margin: 24px 0;">AI 录音设备</div>
                <div class="flexBw">
                  <el-select v-model="curDevice.deviceId" placeholder="请选择" @change="switchMedia" style="width: 94%;"
                    :disabled="isRecord || !!count">
                    <el-option v-for="item in mediaList" :key="item.deviceId" :label="item.label" :value="item.deviceId">
                    </el-option>
                  </el-select>
                  <span class="iconfont recite_icon_again shuaxin" @click="getAllMedias"></span>
                </div>
              </div>
              <div class="fModel fRecord">
                <div class="flexBw">
                  <div class="fTitle flex"><span class="iconfont weixuanzhong"></span> AI 全文练习作品录制</div>
                  <div class="flex-center">
                    <ElSwitch v-model="curDevice.isPreview" active-color="#FB7C33" style="margin-right: 8px;"
                      :disabled="isEnd"></ElSwitch>作品免预览
                  </div>
                </div>
                <div class="fTip flexBw">
                  准备就绪后，请点击下方【开始录音】开始练习
                  <div class="flexBw" v-if="isEnd && isTestEvn">
                    <ElButton type="warning" size="small" @click="downBlob(1)">导出</ElButton>
                    <ElButton type="warning" size="small" @click="downBlob(0)">无压导出</ElButton>
                  </div>
                </div>
                <div class="flexBw">
                  <span class="rdTime">{{ meter }}</span>
                  <Slider ref="slider" v-model="recordRate" :show-tooltip="false" :disabled="!isEnd"
                    style="flex: 1; margin: 0 20px;" @input="changeAudio"></Slider>
                  <span class="rdTime">{{ allMeter }}</span>
                </div>
                <div class="flex-center frBtns">
                  <div class="flex-center flex-v rBtn" @click.stop="resetRecord(true)" v-show="isRecord || isEnd">
                    <span class="flex-center iconfont recite_icon_again"></span>
                    <p>重读</p>
                  </div>
                  <div class="flex-center flex-v rBtn lBtn" @click.stop="isEnd ? handlePlay() : onInitStart()"
                    v-show="!isRecord">
                    <span class="flex-center iconfont langdutubiao" v-show="!isEnd"></span>
                    <span class="flex-center iconfont " :class="isPlaying ? 'xingzhuangjiehe2' : 'lujing1'"
                      v-show="isEnd"></span>
                    <p>{{ isEnd ? '' : '开始录音' }}</p>
                  </div>
                  <div class="flex-center flex-v rBtn lBtn" @click.stop="keepOrPauseRecord" v-show="isRecord">
                    <img src="https://llss-file.langsounds.com/miniapp/15c1d7c1106078df2de4a752ca0a67ec.png"
                      v-show="isRecording" />
                    <span class="flex-center iconfont langdutubiao" v-show="!isRecording"></span>
                    <p>{{ meter }}</p>
                  </div>
                  <div class="flex-center flex-v rBtn" @click.stop="isEnd ? handleEvaluate() : finishRecord()"
                    v-show="isRecord || isEnd">
                    <span class="flex-center iconfont xingzhuangjiehe"></span>
                    <p>{{ isEnd ? 'AI分析' : '完成' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fRight fUsers" v-if="$route.query.classesId">
            <Students :scoreSets="scoreSets" :selectedStudentId="stdInfo.stdId" :disabled="isRecord || isEnd" @onSelect="onSelect" @openReport="getReport"/>
          </div>
        </div>
      </div>
    </Drawer>
    <div class="el-drawer__wrapper cusWrap flex-center" style="z-index: 9999;" v-if="evalResult.status">
      <div class="flex-center rLevel">
        <i class="el-icon-close close" @click="evalResult.status = false"></i>
        <img :src="evalResult.icon" />
        <p class="rlTxt flex-center">{{ evalResult.txt }}</p>
        <div class="flex-center rlBtns">
          <button class="reset" @click="resetRecord(true)">再来一次</button>
          <button class="report" @click="getReport()">查看报告</button>
        </div>
      </div>
    </div>
    <div class="el-drawer__wrapper cusWrap flex-center" style="z-index: 9999;" v-if="count">
      <div class="rTime flex-center">{{ count }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Drawer, Select, Option, Switch, Slider, Button } from "element-ui";
import LyricManager from 'business/LyricManager';
import recordMixin from '../../mixin/record'
import audioMixin from "mixin/audio";
import Students from './students.vue'

let currentStream;
export default {
  mixins: [audioMixin, recordMixin],
  props: {
    iframeMessage: {},
    isSingle: false//单句点读
  },
  data() {
    return {
      isTestEvn: process.env.NODE_ENV !== "production",
      status: false,
      noValid: false,
      artObj: {},
      mediaList: [],
      curDevice: {
        isPreview: false
      }
    }
  },
  components: {
    Students,
    LyricManager,
    Drawer,
    Slider,
    ElSwitch: Switch,
    ElSelect: Select,
    ElOption: Option,
    ElButton: Button,
  },
  mounted() {

  },
  methods: {
    resetDrawerState() {
      this.stdInfo = {}
      this.scoreSets = {}
    },
    onSelect(item) {
      // if(this.stdId != id)this.resetRecord(true); 
      this.stdInfo = item;
    },
    closeRecord() {
      this.resetDrawerState();
      this.$emit('onClose');
      this.delRecord()
    },
    onInitStart() {
      if (this.noValid) {
        this.$toast("无法访问麦克风，请检查权限和设备设置");
      } else {
        this.$emit('onStart')
        this.startRecording()
      }
    },
    onValidMarm() {
      this.noValid = true;
      this.$toast("无法访问麦克风，请检查权限和设备设置");
    },
    checkDevices() {
      // 判断当前环境是否支持
      if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === "function") {
        if (!this.mediaList.length) this.getAllMedias()
      } else {
        this.onValidMarm()
      }
    },
    openDrawer(content) {
      this.checkDevices();
      sessionStorage.removeItem('evalReport')
      const matches = content?.match(/[\p{Script=Han}]/gu) || [];
      this.artObj = {
        content,
        count: matches.length,
        rate: 0
      }
      this.resetRecord(true);
      this.resetDrawerState();
      this.status = true;
      this.$nextTick(() => {
        document.querySelector('.fRight').scrollTo({
          top: 700,
          behavior: 'smooth' // 可选，添加平滑滚动效果
        });
      })
    },
    getReport(id) {
      this.evalResult.status = false;
      if(id)sessionStorage.setItem("evalReport",JSON.stringify(this.scoreSets[id]))
      this.$emit('openReport')
    },
    async getAllMedias() {
      try {
        // 先获取麦克风权限
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true }); // 请求权限
        const devices = await navigator.mediaDevices.enumerateDevices();
        this.mediaList = devices.filter(item => item.kind === 'audioinput' && !item.label.includes("通讯"));
        // 获取当前正在使用的音频 track
        const audioTrack = stream.getAudioTracks()[0];
        this.curDevice = audioTrack.getSettings();
        console.log('当前麦克风设备的 deviceId:', this.curDevice);
      } catch (error) {
        this.onValidMarm()
      }
    },
    // 获取当前设备
    getCurMedia() {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          const audioTrack = stream.getAudioTracks()[0];
          // currentStream = stream;
          this.curDevice = audioTrack.getSettings();
          console.log('当前麦克风设备的 deviceId:', audioTrack);
        })
        .catch(error => {
          console.error('获取音频流失败', error);
        });
    },
    switchMedia(selectedDeviceId) {
      console.log('切换麦克风设备的:', selectedDeviceId);
      // 停止当前的音频流（如果存在）
      if (currentStream) {
        currentStream.getTracks().forEach(track => track.stop());
      }

      // 重新获取指定麦克风的音频流
      navigator.mediaDevices.getUserMedia({
        audio: { deviceId: { exact: selectedDeviceId } }
      })
        .then(stream => {
          currentStream = stream;
          console.log('已切换到新麦克风设备', stream.getTracks);
        })
        .catch(error => {
          console.error('切换麦克风失败', error);
        });
    }
  },
}

</script>

<style lang="less" scoped>
.cusWrap {
  position: absolute !important;
}
.rTime {
  width: 300px;
  height: 300px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 20px;
  font-weight: bold;
  font-size: 200px;
  color: #FFFFFF;
  z-index: 2005;
}

.fTitle {
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  align-items: center;
}

.shuaxin {
  cursor: pointer;
  padding: 0 6px;
  color: #FB7C33;
  font-size: 20px;
}

.fModel {
  background: #FFFCF7;
  border-radius: 20px;
  border: 1px solid #F5EDDF;
  padding: 30px 40px;
}

.fTip {
  font-size: 16px;
  color: #666666;
}

.fHead {
  .fTitle;
  height: 70px;
  line-height: 70px;
  background: #FFFCF7;
  padding-left: 60px;
  position: relative;
  &::before {
    content: "";
    width: 6px;
    height: 16px;
    background: #FB7C33;
    border-radius: 3px;
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
  }
  .close {
    font-size: 30px;
    padding: 10px;
    cursor: pointer;
    color: #999999;
    margin-right: 30px;
  }
}

/deep/.el-drawer {
  // height: 92% !important;
  max-height: 900px;
}

/deep/.el-slider__button {
  border-color: #FB7C33;
}

.fMain {
  height: 100%;
  max-height: 900px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  // max-height: 900px;
  box-sizing: border-box;
}

.fWrap {
  padding: 40px;
  flex: 1;
  overflow: auto;
  align-items: stretch;
}
.noScroll {
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
  }
}
.fLeft {
  .fModel;
  .noScroll;
  // width: 44%;
  overflow: auto;
  padding-top: 20px;
  position: relative;
  flex: 1;
  &.noPad {
    padding: 0;
  }
  .mask {
    position: absolute;
    bottom: 0;
    background: #fff;
    height: 100px;
    width: 100%;
    opacity: .4;
    cursor: not-allowed;
  }
}

.fRight {
  .noScroll;
  overflow: auto;
  // flex: 1;
  width: 30%;
  margin: 0 24px;
  flex-shrink: 0;

  .frWrap {
    height: 100%;
    min-height: 694px;
    // overflow: auto;
    flex-direction: column;
  }

  .fTitle {
    .iconfont {
      font-size: 12px;
      color: #FB7C33;
      transform: scale(.8);
      display: inline-block;
      margin-right: 10px;
    }
  }

  .fMedia {
    // height: 320px;
    margin-bottom: 24px;

    .fmTip {
      line-height: 34px;
      margin-top: 14px;
    }
  }

  .fRecord {
    flex: 1;
    overflow: hidden;

    .fTip {
      margin-top: 16px;
      margin-bottom: 20px;
    }

    .rdTime {
      font-size: 14px;
      color: #666;
    }

    .frBtns {
      // width: 78%;
      margin: 34px auto 0;

      .rBtn {
        font-size: 20px;
        color: #333333;
        cursor: pointer;

        &.lBtn {
          margin: 0 20%;

          .iconfont {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            font-size: 40px;
            background: #FB7C33;
            box-shadow: 0px 0px 0px 9px rgba(251, 124, 51, .1);
            color: #fff;
            margin-bottom: 24px;
          }

          img {
            width: 100px;
            height: 100px;
            margin-bottom: 24px;
          }
        }

        &:not(.lBtn) .iconfont {
          width: 80px;
          height: 80px;
          background: rgba(255, 255, 255, 0);
          border: 2px solid #FB7C33;
          color: #FB7C33;
          border-radius: 50%;
          font-size: 30px;
          box-sizing: border-box;
          margin-bottom: 12px;
        }
      }
    }
  }

  /deep/.el-slider__runway {
    // margin: 0 16px;
    cursor: pointer !important;

    .el-slider__bar {
      background-color: #FB7C33 !important;
    }
  }
}

.fUsers {
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #DDDDDD;
  width: 440px;
  margin: 0;
}

.rLevel {
  flex-direction: column;
  width: 620px;
  height: 541px;
  background: #FFFFFF;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 40px;
  cursor: pointer;
  position: relative;

  .close {
    font-size: 36px;
    position: absolute;
    padding: 10px;
    top: 24px;
    right: 24px;
    cursor: pointer;
    color: #999999;
  }

  img {
    width: auto;
    height: 325px;
    margin-top: -60px;
  }

  .rlTxt {
    width: 549px;
    height: 100px;
    border-radius: 5px;
    border: 2px dashed rgba(251, 124, 51, 0.2);
    font-size: 24px;
    color: #FB7C33;
    font-weight: bold;
    margin-top: -15px;
    margin-bottom: 32px;
  }

  .rlBtns {
    button {
      width: 185px;
      height: 49px;
      background: rgba(251, 124, 51, 0.10);
      border-radius: 25px;
      font-size: 20px;
      color: #FB7C33;

      &.report {
        background: #FB7C33;
        color: #FFFFFF;
        margin-left: 30px;
      }
    }
  }
}
</style>

<style lang="less">
.recordModel .word-display {
  // transform: scale(1.4);
  // transform-origin: left top; 
  white-space: normal;
  // width: 72%;
  padding-top: 4%;
  max-height: 100%;
  height: auto;
}
</style>
